import React, { useEffect, useState } from 'react';
import {
    LiveKitRoom,
    VideoConference,
    RoomAudioRenderer,
    useConnectionState,
    useLocalParticipant,
} from '@livekit/components-react';
import { ConnectionState } from 'livekit-client';
import '@livekit/components-styles';
import './CallModal.css';

// Внутренний компонент для управления UI и кнопкой завершения
function CallContent({ onEndCall, chatTitle, isVideo, participants }) {
    const connectionState = useConnectionState();
    const { localParticipant } = useLocalParticipant();
    const [elapsed, setElapsed] = useState(0);

    // Таймер звонка
    useEffect(() => {
        if (connectionState !== ConnectionState.Connected) return;
        const timer = setInterval(() => setElapsed(prev => prev + 1), 1000);
        return () => clearInterval(timer);
    }, [connectionState]);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
        const secs = (seconds % 60).toString().padStart(2, '0');
        return `${mins}:${secs}`;
    };
    // Проверяем, есть ли видео у участников
    const hasRemoteVideo = participants?.some(p => 
        p.tracks.some(t => t.source === 'camera' && !t.isMuted)
    );

    
    return (
        <div className="call-ui-wrapper">
            {/* Красивый фон, если нет видео */}
            {!hasRemoteVideo && !isVideo && (
                <div className="call-empty-state">
                    <div className="call-avatar-large">
                        <i className="bi bi-person-circle"></i>
                    </div>
                    <h2 className="call-peer-name">{chatTitle || 'Собеседник'}</h2>
                    <p className="call-timer-large">
                        {connectionState === ConnectionState.Connected ? formatTime(elapsed) : 'Подключение...'}
                    </p>
                </div>
            )}

            {/* Само видео (если есть) */}
            <VideoConference />

            {/* Нижняя панель управления */}
            <div className="call-bottom-controls">
                <div className="custom-control-bar">
                    {/* Кнопки LiveKit встроены, мы добавим только свою кнопку завершения */}
                </div>
                
                <button className="custom-end-call-btn" onClick={onEndCall} title="Завершить звонок">
                    <i className="bi bi-telephone-x-fill"></i>
                </button>
            </div>
        </div>
    );


}

export default function CallModal({ token, serverUrl, isVideo, onEndCall, chatTitle, chatId, otherUserId, onDisconnected }) {
    const [isConnected, setIsConnected] = useState(false);
    const [canUseVideo, setCanUseVideo] = useState(isVideo);

    useEffect(() => {
        if (!isVideo) return;
        
        // Проверяем, доступна ли камера
        navigator.mediaDevices.enumerateDevices().then(devices => {
            const hasCam = devices.some(d => d.kind === 'videoinput');
            if (!hasCam) {
                console.warn('No camera found, disabling video');
                setCanUseVideo(false);
            }
        });
    }, [isVideo]);

    return (
        <div className="call-overlay">
            <div className="call-container">
                {/* Заголовок с именем собеседника */}
                {/* <div className="call-header">
                    <div className="call-header-info">
                        <i className="bi bi-person-circle"></i>
                        <span>{chatTitle || 'Собеседник'}</span>
                    </div>
                </div> */}

                <LiveKitRoom
                    token={token}
                    serverUrl={serverUrl}
                    connect={true}
                    video={canUseVideo}
                    audio={true}
                    onConnected={() => setIsConnected(true)}
                    onDisconnected={onDisconnected}
                    onError={(err) => {
                        console.error('LiveKit Room error:', err);
                        if (err.name === 'NotAllowedError' || err.name === 'NotReadableError') {
                            console.warn('Camera not available, continuing without video');
                            // Не отключаем звонок, просто не показываем видео
                        }
                    }}
                    style={{ height: '100%', width: '100%' }}
                >
                    <RoomAudioRenderer />
                    <CallContent 
                        onEndCall={() => onEndCall(chatId, otherUserId)} 
                        chatTitle={chatTitle} 
                        isVideo={canUseVideo}                    
                    />
                </LiveKitRoom>
            </div>
        </div>
    );
}